import React, { useState } from "react";
import { FaTimes, FaMapMarkerAlt, FaMousePointer, FaSlidersH } from "react-icons/fa";
import "./WelcomeModal.css";

const WelcomeModal = ({ setShowWelcomeModalState }) => {
  const [closing, setClosing] = useState(false);

  const handleClose = () => {
    setClosing(true);
    setTimeout(() => {
      setShowWelcomeModalState(false);
    }, 300); // Wait for fade-out animation to finish
  };

  return (
    <div className="modal-overlay">
      <div className={`welcome-modal-content ${closing ? "hide" : ""}`}>
        {/* Close Button */}
        <button className="close-btn" onClick={handleClose}>
          <FaTimes />
        </button>

        {/* Title */}
        <h2 className="modal-title">Welcome to Brahmand – Your Map, Your Control</h2>

        {/* Body Content */}
        <div className="modal-body">
          <p>
            <FaMapMarkerAlt className="icon" /> <strong>Those colored dots?</strong>  They aren’t just random pixels. They’re actual events happening around you.  
          </p>
          <p>
            <FaMousePointer className="icon" /> <strong>Want to see more?</strong> Double-click on any dot to reveal its secrets and uncover the evidence.
          </p>
          <p>
            <FaSlidersH className="icon" /> <strong>Like customization?</strong> Use the dropdown in the top-left to tweak and explore however you want.
          </p>
        </div>

        {/* Got It Button */}
        <button className="got-it-btn" onClick={handleClose}>Got It, Let's Go</button>
      </div>
    </div>
  );
};

export default WelcomeModal;